import { createFileRoute, notFound } from "@tanstack/react-router";
import lolStyles from "../styles/platform-lol.css?url";
import type { StructuredData } from "../../src/lib/structured-data";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { LolPage } from "../platform/lol-page";
import { loadLolPage } from "../platform/product-pages";

/** Drate's page for League of Legends creators (/lol); a 404 on creator sites. */
export const Route = createFileRoute("/lol")({
  loader: async () => {
    const page = await loadLolPage();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/lol",
            title: "League of Legends creator website, app and memberships | Drate",
            description:
              "Build your League of Legends site, matchup guides and member app in minutes. Your look, your domain, your memberships. Used by QuanteLoL, Komari and Viper.",
            structuredData: JSON.parse(loaderData.structuredData) as StructuredData,
          }),
          lolStyles,
        )
      : {},
  component: () => <LolPage page={Route.useLoaderData()} />,
});
